import { type ReactNode } from 'react';
import {
    ComponentDetailsCard,
    fromComponent,
} from '@components/ComponentDetailsCard';
import { type ComponentProps } from '../../models/ComponentProps';

export function ComponentDetailsTab({ component }: ComponentProps): ReactNode {
    return <ComponentDetailsCard data={fromComponent(component)} />;
}
